import FinalBrandStraightening from '../../../assets/images/landing-page/final-brand-straightening.png'


const FinalBrandCta = ({ setIsSignUpOpen }) => {
  return (
    <section
      className="tikbox-services final-brand-cta"
      aria-labelledby="final-brand-heading"
    >
      <div className="dark-bg">

        <div className="tikbox-content">

          <div className="final-brand-cta__why">
            <h2 id="final-brand-heading">
              Why sorting it out matters
            </h2>

            <p>
              Generative AI has transformed how content is created, distributed
              and used. The infrastructure around rights, permissions,
              provenance, and transparency has not kept pace.
            </p>

            <p>
              The challenge is multifaceted. The people and organisations
              behind content can lose context, control, and opportunities to
              capture value. The organisations using and publishing it face
              new questions about what they can use, what they need to disclose,
              and what they can prove.
            </p>

            <p>
              New requirements need new infrastructure. Sorting out the mess
              means making digital content easier to govern, easier to verify
              and easier to value. TikBox is building that infrastructure.
            </p>
          </div>


          <div className="final-brand-cta__divider" />


          <div className="final-brand-cta__manifesto">
            <h3>Make Rights, Not Wrongs.</h3>

            <button
              type="button"
              onClick={() => setIsSignUpOpen(true)}
            >
              Start with TikBox
            </button>
          </div>

        </div>


        {/* Final visual reminder: TikBox straightens out the mess */}
        <div
          className="final-brand-cta__visual"
          aria-hidden="true"
        >
          <img
            src={FinalBrandStraightening}
            alt=""
          />
        </div>

      </div>
    </section>
  )
}

export default FinalBrandCta